/**
 * Feature switches: features that are built but stay hidden until switched on.
 *
 * A switch is on only when its build variable is exactly "true" (Create React
 * App bakes REACT_APP_* in at build time, so switching needs a rebuild/redeploy).
 *
 * - REACT_APP_FEATURE_TV_SCREEN: venue screen (TV view), /screen/league/:id and
 *   the "Open TV screen" button. The API needs FEATURE_TV_SCREEN=true as well.
 */

const isOn = (value) => String(value || '').trim().toLowerCase() === 'true';

export const isTvScreenEnabled = () => isOn(process.env.REACT_APP_FEATURE_TV_SCREEN);
